import { dateToUTC, parseAsDateUTC, createUTCDate, createFormatters } from 'app/infrastructure/data/date';
import { SimpleFormComponentProps, SimpleFormMethods } from 'app/infrastructure/simple-form/types';
import { DateTime } from 'ui';
import * as React from 'react';

export const dateTimeCreator = (props: SimpleFormComponentProps, fieldMethods: SimpleFormMethods, fieldState?: any) => {
    const formatters: any = createFormatters(props.locale);
    return <DateTime
        onChange={fieldMethods.handleChange(props.name)}
        componentId={props.name}
        className={props.className}
        label={fieldMethods.buildLabel(props.label)}
        value={fieldMethods.getProperty(props.name)}
        placeholder={props.placeholder}
        ref={fieldMethods.createRefToScrollableComponent(props.name)}
        locale={props.locale}
        useTime={props.useTime}
        readOnly={props.readOnly}
        validation={fieldMethods.getValidation(props.name)}
        createDate={createUTCDate}
        parseDate={parseAsDateUTC}
        cloneDate={dateToUTC}
        captionWrapper={'form'}
        {...formatters}
    />;
};
